import { useStore } from '@/store'
import { PriceChangePercentage } from '@/types/bubbles.type'
import { ButtonGroupRadio } from '@/ui-components/button-group-radio'
import { SearchInput } from '@/ui-components/search-input'

import styles from './styles.module.scss'

const buttons = [
  { value: PriceChangePercentage.HOUR, content: '1H' },
  { value: PriceChangePercentage.FOUR_HOURS, content: '4H' },
  { value: PriceChangePercentage.TWELVE_HOURS, content: '12H' },
  { value: PriceChangePercentage.DAY, content: '24H' },
]
const Header = () => {
  const { searchCoin, setSearchCoin } = useStore()

  return (
    <header className={styles.header}>
      <ButtonGroupRadio buttons={buttons} />

      <SearchInput
        placeholder="Search cryptocurrency"
        setSearchInput={setSearchCoin}
        searchInput={searchCoin}
      />
    </header>
  )
}
export { Header }
